'use client';

import { useMemo } from 'react';

import { projectApi } from '@highlight-cp/project-api';

import { useGetCurrentUser } from '../use-get-current-user';
import { decorateOrgTeams } from './utils';

const useGetCurrentOrgTeams = () => {
  const { data: user, isLoading: isLoadingUser } = useGetCurrentUser();
  const { data, isLoading: isLoadingTeams } = projectApi.useGetTeamsQuery(
    {
      organizationId: user?.organization?.id,
    },
    {
      skip: !user?.organization?.id,
    },
  );

  const teams = useMemo(() => (data ? decorateOrgTeams(data) : undefined), [data]);

  return {
    data: teams,
    isLoading: isLoadingUser || isLoadingTeams,
  };
};

export default useGetCurrentOrgTeams;
